import React, { ReactNode } from 'react';
import { RxCross1 } from 'react-icons/rx';

type ChipProps = {
    children: ReactNode;
    theme?: 'primary' | 'secondary';
    className?: string;
    onDelete?: () => void;
};

const themeClasses = {
    regular: {
        primary: 'px-3 py-1 rounded-full bg-primary-500 text-white',
        secondary: 'px-3 py-1 rounded-full bg-secondary-500 text-white',
    },
    bold: {
        primary: 'px-2 py-1 rounded-md bg-primary-400 text-primary-100',
        secondary: 'px-2 py-1 rounded-md bg-secondary-400 text-secondary-100',
    }

};


const ChipBase: React.FC<ChipProps & { variant: "regular" | "bold" }> = ({
    variant,
    children,
    theme = 'primary',
    onDelete,
}) => {
    return (
        <div className={`flex flex-row gap-4 items-center ${themeClasses[variant][theme]}`}>
            {children}
            {onDelete && <RxCross1 className='cursor-pointer w-3 h-3 hover:text-primary-800 transition-all duration-200' onClick={onDelete} />}
        </div>
    );
};


export const Chip: React.FC<ChipProps> = (props) => <ChipBase {...props} variant="regular" />;
export const BoldChip: React.FC<ChipProps> = (props) => <ChipBase {...props} variant="bold" />;